import FacebookTargetingGeolocations from '@/descriptors/FacebookTargetingGeolocations';
import BaseEntity from '@/entities/BaseEntity';

export default class FacebookTargeting extends BaseEntity {
  genders = 'all';
  age_min = 18;
  age_max = 65;
  geo_locations = new FacebookTargetingGeolocations();
  excluded_geo_locations = new FacebookTargetingGeolocations();
  locales = [];

  _entityFields = {
    geo_locations: FacebookTargetingGeolocations,
    excluded_geo_locations: FacebookTargetingGeolocations,
  };

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }

  toObject() {
    const data = super.toObject();

    // Excluded side only: Meta no longer accepts a radius drawn around a city/place
    // for exclusions (error 100 / subcode 3858788). Convert those radius-based
    // excluded cities/places into custom_locations using the coordinates already
    // resolved into their meta. The included (geo_locations) side is left untouched.
    const excluded = data.excluded_geo_locations;
    if (!excluded) {
      return data;
    }

    const customLocations = Array.isArray(excluded.custom_locations)
      ? [ ...excluded.custom_locations ]
      : [];

    const keptCities = [];
    const keptPlaces = [];

    const convert = (rows, kept) => {
      (rows || []).forEach(row => {
        const lat = row.meta && parseFloat(row.meta.latitude);
        const lng = row.meta && parseFloat(row.meta.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          // Without valid coordinates (e.g. the metadata fetch has not returned
          // yet) we cannot convert — keep the original entry so nothing is lost.
          // Number.isFinite (not truthiness) so a real 0 latitude/longitude
          // (equator / prime meridian) is still converted rather than left as a
          // radius-around-city exclusion that Meta rejects (error 100 / 3858788).
          kept.push(row);
          return;
        }

        customLocations.push({
          latitude: lat,
          longitude: lng,
          radius: row.radius,
          distance_unit: 'kilometer',
          name: (row.meta && row.meta.name) || null,
          country_code: (row.meta && row.meta.country_code) || null,
        });
      });
    };

    convert(excluded.cities, keptCities);
    convert(excluded.places, keptPlaces);

    excluded.cities = keptCities;
    excluded.places = keptPlaces;
    if (customLocations.length) {
      excluded.custom_locations = customLocations;
    }

    return data;
  }

  get hasGeoOverlaps() {
    return this.geo_locations.hasOverlaps || this.excluded_geo_locations.hasOverlaps;
  }

  get hasInvalidGeoExclude() {
    for (const item of this.excluded_geo_locations.all) {
      if (!this.geo_locations.parentSelected(item)) {
        return true;
      }
    }

    return false;
  }
}
